<ng-container *ngIf="checkPopupList()">
  <div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':displayStyle}">
  <div class="modal-dialog" role="document">
    <div class="modal-content popup-bg">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closePopup()">x</button>
      </div>
      <div class="modal-body">
        <div class="swiper swiper-popup" appSwiper [config]="config" *ngIf="content$.length > 0" #swiperRef>
            <div class="swiper-wrapper">
              <ng-container *ngIf="!skeletonLoading; else skeletonAnnouncementPopup">
                <div class="swiper-slide" *ngFor="let item of content$">
                  <div class="container-fluid">
                    <ng-container *ngIf="item.desktop_link && item.media_type == 1">
                        <object  *ngIf='displayVideoType(item.desktop_link) == "youtube"' class="w-100 video-height" [data]="getUrl(item.desktop_link)"></object>
                    </ng-container>
                    <ng-container *ngIf="item.desktop_link && item.media_type == 2">
                        <img class="img-fluid" [src]="item.desktop_link" alt="desktop image">
                    </ng-container>
                    <h3 *ngIf="item.title" class="popup_title w-75 m-auto">{{ item.title }}</h3>
                    <div class="popup_content  w-75 m-auto" *ngIf="item.content">
                      <p [innerHTML]="item.content"></p>
                    </div>
                    <div class="d-flex" style="justify-content: space-between;">
                      <button *ngIf="item.cta_button_text_1 && item.cta_button_link_1" type="button" class="btn btn-lg btn-block popup_button w-50 m-auto" [ngClass]="item.cta_button_text_2 && item.cta_button_link_2? 'm-r-20' : ''" (click)="onRedirect(item, item.cta_button_link_1)" >{{ item.cta_button_text_1 | uppercase }}</button>
                      <button *ngIf="item.cta_button_text_2 && item.cta_button_link_2" type="button" class="btn btn-lg btn-block popup_button w-50 m-auto" (click)="onRedirect(item, item.cta_button_link_2)" >{{ item.cta_button_text_2 | uppercase }}</button>
                    </div>
                    <div class="mt-3 text-center" *ngIf="item.do_not_show_again">
                      <input type="checkbox" id="doNotShowAgain-{{ item.id }}" (change)="doNotShowAgain(item, $event)"/>
                      <label for="doNotShowAgain-{{ item.id }}" class="ml-2" [ngClass]="'dnsa-text'">Do not show again</label>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #skeletonAnnouncementPopup>
                <div class="swiper-slide" *ngFor="let item of [].constructor(1); let i = index">
                  <div class="container-fluid">
                    <div class="skeleton skeleton-video-height"></div>
                    <h3>
                      <div class="skeleton skeleton-popup-title m-t-20"></div>
                    </h3>
                    <div class="pb-15 w-75 m-auto">
                      <p class="skeleton skeleton-popup-text"></p>
                      <p class="skeleton skeleton-popup-text"></p>
                    </div>
                    <div class="skeleton skeleton-popup-button-box w-50 m-auto"></div>
                  </div>
                </div>
              </ng-template>
            </div>
        </div>
      </div>
      <div class='swiper-popup'>
        <div class="swiper-pagination-popup page-button"></div>
      </div>
    </div>
  </div>
</div>

</ng-container>
